import Vue from "vue";

import VueRouter from "vue-router";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { dynamic } from "./modules/dynamic";
import cadPage from "./modules/cadPage"; // cad端调用浏览器页面
import enterprise from "./modules/enterprise"; // 企业相关路由
import filePreview from "./modules/filePreview"; // web端分享文件预览
import question from "./modules/question"; // 文件批注
import appView from "@/CommonDP/router/modules/appView"; // app批注
import { beforeEnterCmmon, beforeEnterRegister, beforeEnterPassword, beforeEachproject, afterEachPermiss, moduleCheck } from "./method/method";
import { isPromise } from "@/CommonDP/utils/common";
import { interceptor } from "./utils/index";
import globalParams from "@/CommonDP/utils/globalParams";
import env from "../utils/env";

import { isEqual } from "lodash";

Vue.use(VueRouter);
NProgress.configure({ showSpinner: false });
const { isNavigationFailure, NavigationFailureType } = VueRouter;
const originalNavigation = Object.assign({}, VueRouter.prototype);
// 重写路由跳转方法 - 解决vue路由重复导航错误
function overrideRouter(router) {
  for (const fnKey of ['push', 'replace', 'forward']) {
    router[fnKey] = function () {
      return applyNavigator(originalNavigation[fnKey], this, arguments);
    };
  }
}
function applyNavigator() {
  const navigationArgs = arguments;
  // 处理重复导航的bug
  // return registerTask(Reflect.apply(...navigationArgs)).catch((failure) => {
  //   // 当没有导航任务时,重新再发起处理失败的导航
  //   const isLaster = !navTaskSet.size;
  //   if (isLaster && isNavigationFailure(failure, NavigationFailureType.cancelled)) {
  //     return registerTask(Reflect.apply(...navigationArgs));
  //   }
  // });
}
export const constantRouter = [
  ...enterprise,
  ...filePreview,
  ...question,
  ...appView,
  ...cadPage,
  {
    path: "/",
    redirect: "/login",
    meta: {
      hidden: true
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/CommonDP/pages/login/login.vue"),
    meta: {
      hidden: true
    }
  },
  {
    path: "/mainMg",
    name: "mainMg",
    beforeEnter: beforeEnterCmmon,
    component: () => import("@/CommonDP/pages/mainMg/index.vue"),
    children: dynamic
  },
  {
    path: "/register",
    name: "register",
    beforeEnter: beforeEnterRegister,
    component: () => import("@/CommonDP/pages/register")
  },
  {
    path: "/userAgreement",
    name: "userAgreement",
    component: () => import("@/CommonDP/mongeView/appView/agreement/privacyContent.vue")
  },
  {
    path: "/password",
    name: "password",
    beforeEnter: beforeEnterPassword,
    component: () => import("@/CommonDP/pages/password")
  }, {
    path: "/flow-file",
    name: "flow-file",
    component: () => import("@/CommonDP/VForm/folder/page.vue"),
    props({ query: { preId, path }}) { return { preId, path }; }
  },
  // 没有权限的页面
  {
    path: "/error",
    component: () => import("@/CommonDP/pages/mainMg/error/40x"),
    name: "error"
  }
];

let routerConfig = {
  scrollBehavior: () => ({ y: 0 }),
  routes: interceptor(constantRouter)
};
routerConfig.mode = env.VUE_APP_MODE;

let router;

const routerHistory = [];
function initRouter() {
  // 支持扩展路由
  const routeCustomizeFunc = globalParams.get("fx.routeCustomizeFunc");
  routerConfig = routeCustomizeFunc?.(routerConfig) || routerConfig;
  router = new VueRouter(routerConfig);
  router.beforeEach(async (to, from, next) => {
    const length = routerHistory.length;
    let isRepeat = false;
    if (length > 8) {
      isRepeat = !routerHistory.some((item) => {
        return !isEqual(item, to);
      });
      routerHistory.pop();
    }
    routerHistory.unshift(to);
    if (isRepeat) return;
    // 此处为一个返回promise的函数，为别的项目单点登录或路由守卫做操作
    const beforeEachFn = globalParams.get("beforeEach");
    if (typeof beforeEachFn === "function") {
      await beforeEachFn(to, from, next);
    }
    // 路由表不确定了，所以需要首先获取所有的权限，用户组成路由表,
    // 判断白名单，是否需要不去获取权限，不需要的时候直接next()
    // 判断白名单，是否需要登录获取用户信息，不需要的时候 直接next()
    const isRedirect = await moduleCheck(to, from, next, constantRouter);
    if (isRedirect) {
      return;
    }
    beforeEachproject(to, from, next);
  });
  // 全局 - 进入页面之后
  router.afterEach(async (to) => {
    // 处理路由导航时不方便操作的方法
    for (const route of to.matched) {
      const afterMap = route.meta.after;
      if (afterMap) {
        const fn = afterMap.get(to);
        fn && await fn(to);
        afterMap.delete(fn);
      }
    }
    const afterEachFn = globalParams.get("afterEach");
    isPromise(afterEachFn) && await afterEachFn(router, to);
    afterEachPermiss(router, to);
  });
  return router;
}
export default function () {
  if (router) return router;
  return initRouter();
}

